import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';
import { notificationInit } from '../../modules/notifications/actions';
import {
	GET_TRAILER_TYPES,
	GET_TRAILERS_LIST,
	GET_LIST_TRAILER_FILE_TYPES,
	setIsTrailersListLoadingAction,
	setIsTrailerTypesLoadingAction,
	setPaginationAction,
	setTrailersListAction,
	setTrailerTypesAction,
	setIsDownloadLoadingAction,
} from './actions';
import { getTrailersListRequest, getTrailerTypesRequest, getBlobForReqListRequest } from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import { errorHandler } from '../../api/utils';

export function* getTrailersListSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsTrailersListLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getTrailersListRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setTrailersListAction(
					data?.map(trailer => ({
						...trailer,
						type_name: trailer.type?.name ?? '---',
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=trailer&id=${trailer.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsTrailersListLoadingAction(false));
	}
}

export function* getTypesSaga() {
	try {
		yield put(setIsTrailerTypesLoadingAction(true));

		const { data, message, toast } = yield call(getTrailerTypesRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setTrailerTypesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsTrailerTypesLoadingAction(false));
	}
}

export function* getReqListFileSaga({ payload: { exportUrl } }) {
	try {
		yield put(setIsDownloadLoadingAction(true));

		const response = yield call(getBlobForReqListRequest, exportUrl);

		saveAs(response, 'trailers.xlsx');
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsDownloadLoadingAction(false));
	}
}

export default function* trailersContainerSaga() {
	yield takeEvery(GET_TRAILERS_LIST, getTrailersListSaga);
	yield takeEvery(GET_TRAILER_TYPES, getTypesSaga);
	yield takeEvery(GET_LIST_TRAILER_FILE_TYPES, getReqListFileSaga);
}
